/* FITPEAK：最安ナビのジム店舗行に、店舗レビュー記事の星評価とリンクを追加する
   - データ：assets/gym-hub-reviews.json（name / pref / city / stars / handle）
   - 対象：.fpc-row（あなたの街の最安ジム・都道府県ページ等）。「Googleマップ」ボタンの横に挿入
   - レビューがない店舗には何も出さない */
(function () {
  var s = document.currentScript;
  var src = s && s.getAttribute('data-reviews');
  if (!src) return;
  var map = null;

  function norm(t) {
    return String(t || '')
      .normalize('NFKC')
      .replace(/[\s　・･\-‐－ー（）()【】\[\]「」]/g, '')
      .toLowerCase();
  }

  function starsHtml(v) {
    var pct = Math.max(0, Math.min(100, (v / 5) * 100));
    return '<span class="fp-rv-stars" aria-hidden="true"><span class="fp-rv-base">★★★★★</span>' +
      '<span class="fp-rv-fill" style="width:' + pct.toFixed(1) + '%">★★★★★</span></span>';
  }

  function css() {
    if (document.getElementById('fp-rv-css')) return;
    var st = document.createElement('style');
    st.id = 'fp-rv-css';
    st.textContent =
      '.fpc-buy a.fp-rv{display:inline-flex;align-items:center;gap:6px;white-space:nowrap;text-decoration:none;color:#111!important}' +
      '.fp-rv-stars{position:relative;display:inline-block;letter-spacing:1px;line-height:1;font-size:12px}' +
      '.fp-rv-base{color:#d9d9d9}' +
      '.fp-rv-fill{position:absolute;left:0;top:0;overflow:hidden;white-space:nowrap;color:#e0a13c}' +
      '.fp-rv-num{font-weight:700;font-size:12px}' +
      '.fp-rv-lbl{font-size:11px;text-decoration:underline}';
    document.head.appendChild(st);
  }

  function decorate(root) {
    if (!map) return;
    var rows = (root || document).querySelectorAll('.fpc-row');
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.getAttribute('data-fp-rv')) continue;
      var nm = row.querySelector('.fpc-nm');
      var buy = row.querySelector('.fpc-buy');
      if (!nm || !buy) continue;
      row.setAttribute('data-fp-rv', '1');
      var hit = map[norm(nm.textContent)];
      if (!hit) continue;
      var a = document.createElement('a');
      a.className = 'is-map fp-rv';
      a.href = '/blogs/gym-review/' + encodeURIComponent(hit.handle);
      a.setAttribute('aria-label', hit.name + 'の店舗レビュー（星' + hit.stars.toFixed(2) + '）を読む');
      a.innerHTML = starsHtml(hit.stars) + '<span class="fp-rv-num">' + hit.stars.toFixed(2) + '</span><span class="fp-rv-lbl">レビュー</span>';
      var mapBtn = buy.querySelector('a.is-map:not(.fp-rv)');
      if (mapBtn && mapBtn.nextSibling) buy.insertBefore(a, mapBtn.nextSibling);
      else buy.appendChild(a);
    }
  }

  function start() {
    if (!document.querySelector('.fpc, .fpc-row, .fpc-list')) return;
    css();
    fetch(src).then(function (r) { return r.json(); }).then(function (list) {
      map = {};
      list.forEach(function (x) {
        if (x && x.name && x.handle && typeof x.stars === 'number') map[norm(x.name)] = x;
      });
      decorate(document);
      var t = null;
      new MutationObserver(function () {
        if (t) return;
        t = setTimeout(function () { t = null; decorate(document); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
